import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WA_URL, TG_URL, IG_URL, PHONE_RAW, PHONE_DISPLAY, EMAIL } from "../config/constants";
import "./Footer.css";

export default function Footer() {
  const { t } = useTranslation("common");

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/logo-full.webp" alt="ProNet Real Estate" className="footer-logo-img" />
          </div>
          <p>{t("footer.tagline")}</p>
          <div className="footer-social">
            <a href={IG_URL} target="_blank" rel="noreferrer">Instagram</a>
            <a href={TG_URL} target="_blank" rel="noreferrer">Telegram</a>
            <a href={WA_URL} target="_blank" rel="noreferrer">WhatsApp</a>
          </div>
        </div>
        <div>
          <p className="footer-col-title">{t("footer.nav")}</p>
          <div className="footer-col">
            <Link to="/listings">{t("nav.listings")}</Link>
            <Link to="/blog">{t("nav.blog")}</Link>
            <Link to="/about">{t("nav.about")}</Link>
            <Link to="/contact">{t("nav.contact")}</Link>
          </div>
        </div>
        <div>
          <p className="footer-col-title">{t("footer.properties")}</p>
          <div className="footer-col">
            <Link to="/listings?priceType=sale">{t("footer.forSale")}</Link>
            <Link to="/listings?priceType=rent">{t("footer.forRent")}</Link>
            <Link to="/listings?emirate=Dubai">{t("footer.uae")}</Link>
            <Link to="/international">{t("footer.international")}</Link>
          </div>
        </div>
        <div>
          <p className="footer-col-title">{t("footer.contact")}</p>
          <div className="footer-col">
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            <a href={`tel:${PHONE_RAW}`}>{PHONE_DISPLAY}</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} ProNet Real Estate</p>
        <p>Dubai, UAE</p>
      </div>
    </footer>
  );
}
